import { useMutation } from '@tanstack/react-query';
import type { AIAssistRequest } from 'api/models/AIAssistRequest';
import type { AIAssistResponse } from 'api/models/AIAssistResponse';
import SummaryDefinitionsService from 'services/summaryDefinitions';

export const useAIAssistSummary = (firmId: number) => {
  const service = new SummaryDefinitionsService();

  return useMutation<AIAssistResponse, Error, AIAssistRequest>({
    mutationFn: data => service.aiAssistFirmDefinition(firmId, data),
  });
};
